export const COMPANY_ACTIONS = {
    'COMPANY.DELETE.MODAL.TITLE': 'Ești sigur că vrei să ștergi compania?',
    'COMPANY.DELETE.MODAL.SUBTITLE1': 'Această acțiune nu poate fi reversată și presupune ca:',
    'COMPANY.DELETE.MODAL.SUBTITLE2': 'Utilizatorii:',
    'COMPANY.DELETE.MODAL.CONSEQUENCE1': 'nu pot iniția calcule noi',
    'COMPANY.DELETE.MODAL.CONSEQUENCE2': 'nu pot continua calculele deja începute',
    'COMPANY.DELETE.MODAL.CONSEQUENCE3': 'nu pot încărca documente (inclusiv balanțe)',
    'COMPANY.DELETE.MODAL.CONSEQUENCE4': 'nu pot administra compania (inclusiv atributele) - adaugari, eliminari, editari',
    'COMPANY.DELETE.MODAL.CONSEQUENCE5': 'nu pot exporta calculele și lista de calcule',
    'COMPANY.DELETE.MODAL.SUBTITLE3': 'Atributele Companiei:',
    'COMPANY.DELETE.MODAL.CONSEQUENCE6': 'vor fi șterse calculele asociate acestei companii'
};
